import { RootState } from '../store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { VIEW } from '../../constant'

export interface CommonState {
  isLoading: boolean
  walletAddress: string
  connecting: boolean
  toast: {
    duration?: number
    type?: string
    show: boolean
    title?: string
    message: string
  }
  checkIn: string | null
  checkOut: string | null
  adults: number
  children: number
  infants: number
  pets: number
  stripeComplete: boolean
  typeTooltip: string
  triggerTime: number
  view: string
  isFinishCreditCard: boolean
  isFinishCrypto: boolean
  isFinishGuestInfo: boolean
  accounts: Array<string>
  chainId: string
  cryptoPayment: string
  tokenContract: Array<any>
  isLayoutHasScroll: boolean
}

const initialState: CommonState = {
  isLoading: false,
  walletAddress: '',
  connecting: false,
  toast: {
    duration: 6000,
    type: 'error',
    show: false,
    title: 'Title',
    message: '',
  },
  checkIn: null,
  checkOut: null,
  adults: 0,
  children: 0,
  infants: 0,
  pets: 0,
  stripeComplete: false,
  typeTooltip: '',
  triggerTime: 0,
  view: VIEW.LIST,
  isFinishCreditCard: false,
  isFinishCrypto: false,
  isFinishGuestInfo: false,
  accounts: [],
  chainId: '',
  cryptoPayment: '',
  tokenContract: [],
  isLayoutHasScroll: false,
}

export const commonSlices = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<any>) => {
      state.isLoading = action.payload
    },
    updateWalletAddress: (state: RootState, action: PayloadAction<string>) => {
      state.walletAddress = action.payload
    },
    setToast: (
      state,
      action: PayloadAction<{ type?: string; title?: string; duration?: number; show: boolean; message: string }>
    ) => {
      state.toast = action.payload
    },
    setToastError: (state, action: PayloadAction<{ title?: string; duration?: number; message: string }>) => {
      state.toast = { ...action.payload, type: 'error', show: true }
    },
    setToastSuccess: (state, action: PayloadAction<{ title?: string; duration?: number; message: string }>) => {
      state.toast = { ...action.payload, type: 'success', show: true }
    },
    // manual reservation
    setCheckIn: (state, action: PayloadAction<string | null>) => {
      state.checkIn = action.payload
    },
    setCheckOut: (state, action: PayloadAction<string | null>) => {
      state.checkOut = action.payload
    },
    setAdults: (state, action: PayloadAction<number>) => {
      state.adults = action.payload
    },
    setChildren: (state, action: PayloadAction<number>) => {
      state.children = action.payload
    },
    setInfants: (state, action: PayloadAction<number>) => {
      state.infants = action.payload
    },
    setPets: (state, action: PayloadAction<number>) => {
      state.pets = action.payload
    },
    setStripeComplete: (state, action: PayloadAction<boolean>) => {
      state.stripeComplete = action.payload
    },
    setTypeTooltip: (state, action: PayloadAction<string>) => {
      state.typeTooltip = action.payload
    },
    setTriggerTime: (state, action: PayloadAction<number>) => {
      state.triggerTime = action.payload || +new Date()
    },
    setView: (state, action: PayloadAction<string>) => {
      state.view = action.payload
    },
    setIsFinishCreditCard: (state, action: PayloadAction<boolean>) => {
      state.isFinishCreditCard = action.payload
    },
    setIsFinishCrypto: (state, action: PayloadAction<boolean>) => {
      state.isFinishCrypto = action.payload
    },
    setIsFinishGuestInfo: (state, action: PayloadAction<boolean>) => {
      state.isFinishGuestInfo = action.payload
    },
    setAccounts: (state, action: PayloadAction<Array<string>>) => {
      state.accounts = action.payload
    },
    setChainId: (state, action: PayloadAction<string>) => {
      state.chainId = action.payload
    },
    setCryptoPayment: (state, action: PayloadAction<string>) => {
      state.cryptoPayment = action.payload
    },
    setTokenContract: (state, action: PayloadAction<any[]>) => {
      state.tokenContract = action.payload
    },
    setIsLayoutHasScroll: (state, action: PayloadAction<boolean>) => {
      state.isLayoutHasScroll = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setLoading,
  updateWalletAddress,
  setToast,
  setToastError,
  setToastSuccess,
  setCheckIn,
  setCheckOut,
  setAdults,
  setChildren,
  setInfants,
  setPets,
  setStripeComplete,
  setTypeTooltip,
  setTriggerTime,
  setView,
  setIsFinishCreditCard,
  setIsFinishCrypto,
  setIsFinishGuestInfo,
  setAccounts,
  setChainId,
  setCryptoPayment,
  setTokenContract,
  setIsLayoutHasScroll,
} = commonSlices.actions

export default commonSlices.reducer
